import images from "./images";

const process = [
  {
    id: 1,
    image: images.step1,
    title: 'Initial Consultation',
    content: 'Begin with an in-depth consultation to understand your architectural and interior design needs, style preferences.',
  },
  {
    id: 2,
    image: images.step2,
    title: 'Concept Development',
    content: 'Create innovative design concepts and layout plans that align with your vision, ensuring a unique and functional design.',
  },
  {
    id: 3,
    image: images.step3,
    title: 'Material Selection',
    content: 'Help you choose the finest materials, finishes, and furnishings that match your style and meet quality standards.',
  },
  {
    id: 4,
    image: images.step4,
    title: 'Design Implementation',
    content: 'Turn the chosen design into reality with precision and attention to detail, overseeing construction and installation phases.',
  },
  {
    id: 5,
    image: images.step5,
    title: 'Quality Assurance',
    content: 'Perform quality checks and inspections at various project stages to ensure the highest level of craftsmanship and compliance.',
  },
  {
    id: 6,
    image: images.step6,
    title: 'Final Presentation',
    content: 'Show you the completed design, provide any necessary adjustments, and ensure your complete satisfaction with the project.',
  },
];

export default process;